"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const use_promise_1 = require("../../hook/use-promise");
const passage_list_1 = require("../../network/passage-list");
const fetch_result_renderer_1 = require("../../component/fetch-result-renderer");
const passage_card_1 = require("./passage-card");
const log_view_layout_1 = require("../../component/log-view-layout");
const log_1 = require("../../model/log");
exports.ListPage = (0, react_1.memo)(() => {
    const { result, status, error } = (0, use_promise_1.usePromise)(passage_list_1.getPassageList);
    return ((0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.PassageListPage, children: (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: result, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: {
                flex: 1,
            }, children: (data) => ((0, jsx_runtime_1.jsx)(material_1.Grid2, { container: true, spacing: 2, padding: 2, children: data.map((item) => ((0, jsx_runtime_1.jsx)(material_1.Grid2, { size: {
                        xs: 4,
                        sm: 4,
                        md: 4,
                        lg: 3,
                    }, display: "flex", justifyContent: "center", children: (0, jsx_runtime_1.jsx)(passage_card_1.PassageCard, { passageMeta: item }, item.id) }, item.id))) })
            // <Stack direction={"row"} flexWrap="wrap" gap={4} maxWidth={"100%"}>
            //   {data.map((item) => (
            //     <PassageCard passageMeta={item} key={item.id} />
            //   ))}
            // </Stack>
            ) }) }));
});
exports.ListPage.displayName = "ListPage";
exports.default = exports.ListPage;
